/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCreateScreeningFlowDraft,
    InternalApiCreateScreeningFlowDraftFromJSON,
    InternalApiCreateScreeningFlowDraftToJSON,
    InternalApiEntityType,
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeToJSON,
    InternalApiScreeningFlowDraft,
    InternalApiScreeningFlowDraftFromJSON,
    InternalApiScreeningFlowDraftToJSON,
} from '../models';

export interface ActivateScreeningFlowDraftRequest {
    draftId: number;
}

export interface CreateNewScreeningFlowDraftRequest {
    internalApiCreateScreeningFlowDraft: InternalApiCreateScreeningFlowDraft;
}

export interface CreateScreeningFlowDraftForFlowRequest {
    flowId: string;
    internalApiCreateScreeningFlowDraft: InternalApiCreateScreeningFlowDraft;
}

export interface DeleteScreeningFlowDraftRequest {
    draftId: number;
}

export interface FindOrganisationScreeningFlowDraftsRequest {
    entityType: InternalApiEntityType;
}

export interface FindScreeningFlowDraftsRequest {
    flowId: string;
}

export interface GetScreeningFlowDraftRequest {
    draftId: number;
}

export interface UpdateScreeningFlowDraftRequest {
    draftId: number;
    internalApiCreateScreeningFlowDraft: InternalApiCreateScreeningFlowDraft;
}

/**
 * 
 */
export class InternalScreeningFlowDraftsApi extends runtime.BaseAPI {

    /**
     * Activates a pending screening flow draft
     */
    async activateScreeningFlowDraftRaw(requestParameters: ActivateScreeningFlowDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningFlowDraft>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling activateScreeningFlowDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/screening-flow-drafts/{draftId}/activate`.replace(`{${"draftId"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningFlowDraftFromJSON(jsonValue));
    }

    /**
     * Activates a pending screening flow draft
     */
    async activateScreeningFlowDraft(requestParameters: ActivateScreeningFlowDraftRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningFlowDraft> {
        const response = await this.activateScreeningFlowDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new screening flow draft
     */
    async createNewScreeningFlowDraftRaw(requestParameters: CreateNewScreeningFlowDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningFlowDraft>> {
        if (requestParameters.internalApiCreateScreeningFlowDraft === null || requestParameters.internalApiCreateScreeningFlowDraft === undefined) {
            throw new runtime.RequiredError('internalApiCreateScreeningFlowDraft','Required parameter requestParameters.internalApiCreateScreeningFlowDraft was null or undefined when calling createNewScreeningFlowDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/screening-flow-drafts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateScreeningFlowDraftToJSON(requestParameters.internalApiCreateScreeningFlowDraft),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningFlowDraftFromJSON(jsonValue));
    }

    /**
     * Creates a new screening flow draft
     */
    async createNewScreeningFlowDraft(requestParameters: CreateNewScreeningFlowDraftRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningFlowDraft> {
        const response = await this.createNewScreeningFlowDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a screening flow draft for an existing flow
     */
    async createScreeningFlowDraftForFlowRaw(requestParameters: CreateScreeningFlowDraftForFlowRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningFlowDraft>> {
        if (requestParameters.flowId === null || requestParameters.flowId === undefined) {
            throw new runtime.RequiredError('flowId','Required parameter requestParameters.flowId was null or undefined when calling createScreeningFlowDraftForFlow.');
        }

        if (requestParameters.internalApiCreateScreeningFlowDraft === null || requestParameters.internalApiCreateScreeningFlowDraft === undefined) {
            throw new runtime.RequiredError('internalApiCreateScreeningFlowDraft','Required parameter requestParameters.internalApiCreateScreeningFlowDraft was null or undefined when calling createScreeningFlowDraftForFlow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/flows/{flowId}/drafts`.replace(`{${"flowId"}}`, encodeURIComponent(String(requestParameters.flowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateScreeningFlowDraftToJSON(requestParameters.internalApiCreateScreeningFlowDraft),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningFlowDraftFromJSON(jsonValue));
    }

    /**
     * Creates a screening flow draft for an existing flow
     */
    async createScreeningFlowDraftForFlow(requestParameters: CreateScreeningFlowDraftForFlowRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningFlowDraft> {
        const response = await this.createScreeningFlowDraftForFlowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a pending screening flow draft
     */
    async deleteScreeningFlowDraftRaw(requestParameters: DeleteScreeningFlowDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling deleteScreeningFlowDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/screening-flow-drafts/{draftId}`.replace(`{${"draftId"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a pending screening flow draft
     */
    async deleteScreeningFlowDraft(requestParameters: DeleteScreeningFlowDraftRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteScreeningFlowDraftRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches screening flow drafts for the current organisation
     */
    async findOrganisationScreeningFlowDraftsRaw(requestParameters: FindOrganisationScreeningFlowDraftsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScreeningFlowDraft>>> {
        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling findOrganisationScreeningFlowDrafts.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/screening-flow-drafts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScreeningFlowDraftFromJSON));
    }

    /**
     * Fetches screening flow drafts for the current organisation
     */
    async findOrganisationScreeningFlowDrafts(requestParameters: FindOrganisationScreeningFlowDraftsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScreeningFlowDraft>> {
        const response = await this.findOrganisationScreeningFlowDraftsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches screening flow drafts for a flow
     */
    async findScreeningFlowDraftsRaw(requestParameters: FindScreeningFlowDraftsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScreeningFlowDraft>>> {
        if (requestParameters.flowId === null || requestParameters.flowId === undefined) {
            throw new runtime.RequiredError('flowId','Required parameter requestParameters.flowId was null or undefined when calling findScreeningFlowDrafts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/flows/{flowId}/drafts`.replace(`{${"flowId"}}`, encodeURIComponent(String(requestParameters.flowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScreeningFlowDraftFromJSON));
    }

    /**
     * Fetches screening flow drafts for a flow
     */
    async findScreeningFlowDrafts(requestParameters: FindScreeningFlowDraftsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScreeningFlowDraft>> {
        const response = await this.findScreeningFlowDraftsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches a screening flow draft by id
     */
    async getScreeningFlowDraftRaw(requestParameters: GetScreeningFlowDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningFlowDraft>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling getScreeningFlowDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/screening-flow-drafts/{draftId}`.replace(`{${"draftId"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningFlowDraftFromJSON(jsonValue));
    }

    /**
     * Fetches a screening flow draft by id
     */
    async getScreeningFlowDraft(requestParameters: GetScreeningFlowDraftRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningFlowDraft> {
        const response = await this.getScreeningFlowDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a pending screening flow draft
     */
    async updateScreeningFlowDraftRaw(requestParameters: UpdateScreeningFlowDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningFlowDraft>> {
        if (requestParameters.draftId === null || requestParameters.draftId === undefined) {
            throw new runtime.RequiredError('draftId','Required parameter requestParameters.draftId was null or undefined when calling updateScreeningFlowDraft.');
        }

        if (requestParameters.internalApiCreateScreeningFlowDraft === null || requestParameters.internalApiCreateScreeningFlowDraft === undefined) {
            throw new runtime.RequiredError('internalApiCreateScreeningFlowDraft','Required parameter requestParameters.internalApiCreateScreeningFlowDraft was null or undefined when calling updateScreeningFlowDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/screening-flow-drafts/{draftId}`.replace(`{${"draftId"}}`, encodeURIComponent(String(requestParameters.draftId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateScreeningFlowDraftToJSON(requestParameters.internalApiCreateScreeningFlowDraft),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningFlowDraftFromJSON(jsonValue));
    }

    /**
     * Updates a pending screening flow draft
     */
    async updateScreeningFlowDraft(requestParameters: UpdateScreeningFlowDraftRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningFlowDraft> {
        const response = await this.updateScreeningFlowDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
